import {Button, TextField, Typography} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import EmailValidator from 'email-validator';
import {ChangeEvent, FormEvent, useState} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';

import FormSubmitModal from 'src/Components/Common/FormSubmitModal/FormSubmitModal';

import {contactUsFormStyles} from './contactUsFormStyles';

const ContactUsForm = (props: IContactUsFormProps) => {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [mailError, setMailError] = useState(false);
	const [nameError, setNameError] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		setName(event.target.value);
		setNameError(false);
	};
	const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);
		setMailError(false);
	};
	const onCloseModal = (value: boolean) => {
		setShowModal(value);
	};
	const sendFormData = (e: FormEvent) => {
		e.preventDefault();

		if (name.length < 1) {
			setNameError(true);
		}

		if (!EmailValidator.validate(email)) {
			setMailError(true);
		}

		setShowModal(true);
	};

	return (
		<Box className={props.classes.wrapper} component="div" data-rounded>
			<Typography variant="h2" className={props.classes.formTitle}>
				{props.t('contactus')}
			</Typography>
			<Typography variant="subtitle1" className={props.classes.formSubTitle}>
				{props.t('formtitle')}
			</Typography>
			<form noValidate onSubmit={sendFormData}>
				<TextField
					type="email"
					className={props.classes.input}
					id="email"
					value={email}
					onChange={handleEmailChange}
					error={mailError}
					variant="filled"
					color="secondary"
					fullWidth
					helperText={mailError && props.t('formerror')}
					FormHelperTextProps={{
						className: props.classes.helperText,
					}}
					label={props.t('formemailplaceholder')}
				/>
				<TextField
					type="text"
					className={props.classes.input}
					error={nameError}
					helperText={nameError && props.t('formerror')}
					label={props.t('formname')}
					id="name"
					value={name}
					onChange={handleNameChange}
					variant="filled"
					color="secondary"
					FormHelperTextProps={{
						className: props.classes.helperText,
					}}
					fullWidth
				/>
				<Button
					color="secondary"
					variant="contained"
					disableElevation={true}
					size="large"
					type="submit"
					className={props.classes.buttonSubmit}
				>
					{props.t('getintouch')}
				</Button>
			</form>
			<Typography variant="subtitle2" className={props.classes.formDescription}>
				{props.t('formdescription')}
			</Typography>
			<Box className={props.classes.square}>
				<Box className={props.classes.sphere} />
			</Box>
			<FormSubmitModal onCloseModal={onCloseModal} showModal={showModal} hasError={nameError || mailError} />
		</Box>
	);
};

interface IContactUsFormProps extends WithStyles, WithTranslation {
	onCloseModal: (value: boolean) => void;
}

export default withStyles(contactUsFormStyles)(withTranslation('contactus')(ContactUsForm));
